import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import Layout from "../../Layout/Layout";
import ProviderComponent from "../provider/create-edit/provider";
import Profile from "../profile/Profile";
import ProviderListingComponent from "../provider/listing/provider";
import Patient from "../patient/Patient";
import AllPatients from "../patient/AllPatients/AllPatients";
import SetnewpassComponent from "../Setnewpassword/Setnewpass";
import ChatComponent from "../../public/chat/Chat";
import CommunityComponent from "../Community/Community";
import TreatmentPlanPatient from "../patient/TreatmentPlanPatient";
import AdheranceList from "../patient/AdheranceList";
import MediaManagement from "../Media-Managment/MediaManagment";
import AddMedia from "../Media-Managment/AddMedia";
import NotesList from "../patient/NotesList";
import ViewMedia from "../Media-Managment/ViewMedia";
import SurveyList from "../SurveyManagment/SurveyList";
import QuestionList from "../SurveyManagment/QuestionList";
import ResponseSurveyList from "../SurveyManagment/ResponseSurveyList";
import Response from "../SurveyManagment/Response";
import CommunityTopicList from "../Community/CommunityTopicList";
import PageNotFound from "../../Common/Component/PageNotFound";
import AnalyticsMain from "../Analytics/AnalyticsMain";
import FeedbackForm from "../Feedback/FeedbackForm";
import TemplateManager from "../Email Managment/TemplateManager";
import HorizontalCalendar from "../patient/HorizontalCalendar";
import PrivacyPolicyMain from "../../public/privacyPolicy/PrivacyPolicyMain";
import AdminDashboard from "../educationManagment/pages/EducationManagmentPage";

export const AdminRoutes = [
  {
    path: `dashboard`,
    // exact: true,
    layout: Layout,
    component: <Dashboard />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  {
    path: `provider/create`,
    exact: true,
    layout: Layout,
    component: <ProviderComponent />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  {
    path: `provider/edit`,
    exact: true,
    layout: Layout,
    component: <ProviderComponent />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  {
    path: `provider/listing`,
    exact: true,
    layout: Layout,
    component: <ProviderListingComponent />,
    allowedRoles: ["ADMIN" ],

  },
  {
    path: `provider/profile`,
    exact: true,
    layout: Layout,
    component: <Profile />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
    {
    path: `profile`,
    exact: true,
    layout: Layout,
    component: <Profile />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  {
    path: `patient/list`,
    exact: true,
    layout: Layout,
    component: <AllPatients />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },

  {
    path: `community`,
    exact: true,
    layout: Layout,
    component: <CommunityComponent />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },

  {
    path: `forum`,
    exact: true,
    layout: Layout,
    component: <CommunityTopicList />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },

  {
    path: `patient/treatmentList/`,
    exact: true,
    layout: Layout,
    component: <TreatmentPlanPatient />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  {
    path: `patient/adheranceList/`,
    exact: true,
    layout: Layout,
    component: <AdheranceList />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  {
    path: `patient/notes/`,
    exact: true,
    layout: Layout,
    component: <NotesList />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  
  {
    path: `patient`,
    exact: true,
    layout: Layout,
    component: <Patient />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },

     {
        path: `update/password`,
        exact: true,
        layout: Layout,
        component: <SetnewpassComponent />,
        allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
    },
    {
        path: `chat`,
        exact: true,
        layout: Layout,
        component: <ChatComponent />,
        allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
    },
    
    {
      path: `media-management`,
      exact: true,
      layout: Layout,
      component: <MediaManagement />,
      allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  {
    path: `media-management/add-media`,
    exact: true,
    layout: Layout,
    component: <AddMedia />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
},

{
  path: `media-management/view-media`,
  exact: true,
  layout: Layout,
  component: <ViewMedia />,
  allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
},

{
  path: `education-management`,
  exact: true,
  layout: Layout,
  component: <AdminDashboard />,
  allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
},

{
  path: `survey/survey-list`,
  exact: true,
  layout: Layout,
  component: <SurveyList />,
  allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
},

{
  path: `survey/question-list`,
  exact: true,
  layout: Layout,
  component: <QuestionList />,
  allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
},
{
  path: `patient/response-survey-list`,
  exact: true,
  layout: Layout,
  component: <ResponseSurveyList />,
  allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
},
{
  path: `patient/response-list`,
  exact: true,
  layout: Layout,
  component: <Response/>,
  allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
},
    {
      path: `community`,
      exact: true,
      layout: Layout,
      component: <CommunityComponent />,
      allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
    },
  {
    path: `update/password`,
    exact: true,
    layout: Layout,
    component: <SetnewpassComponent />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },

  {
    path: `feedback`,
    exact: true,
    layout: Layout,
    component: <FeedbackForm />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },
  {
    path: `analytics`,
    exact: true,
    layout: Layout,
    component: <AnalyticsMain />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" ],
  },

  {
    path: `template-manager`,
    exact: true,
    layout: Layout,
    component: <TemplateManager />,
    allowedRoles: ["ADMIN"],
  },
  {
    path: `date-pocker`,
    exact: true,
    layout: Layout,
    component: <HorizontalCalendar />,
    allowedRoles: ["ADMIN"],
  },
  {
    path: `policies`,
    exact: true,
    layout: Layout,
    component: <PrivacyPolicyMain />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" , "ALL"  ],
  },
  {
    path: `*`,
    exact: true,
    layout: Layout,
    component: <PageNotFound />,
    allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" , "ALL"  ],

},
];

export default AdminRoutes;
